module.exports = __webpack_public_path__ + "static/media/FT_R_P2.a13c925c.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/wounds/FT_R_P2.png
// module id = 2232
// module chunks = 0